import { useAppSelector } from 'hooks/reduxHooks'

function useAccommodationMapSearchPath(): string {
  const pathname = useAppSelector(state => state.router.location.pathname)
  return pathname.includes('/homes-and-villas') ? '/search/homes-and-villas/map' : '/search/map'
}

export default useAccommodationMapSearchPath
